import Vue from 'vue';
import orderList from '../../components/insurance/order-list.vue';
export default Vue.extend({
    name: 'login',
    components: {
        orderList: orderList,
    },
    created: function () { },
    computed: {},
    watch: {},
    data: function () {
        return {
            activeName: 'first',
            sourceUrl: '/proxy/api/application/list',
        };
    },
    methods: {},
});
